import React from 'react';
import PropTypes from 'prop-types';
import I18n from './I18n';

const Errors = ({errors}) => {
  let k, list;
  if (typeof errors === 'string') {
    list = [errors];
  } else if (typeof errors === 'object' && !(errors instanceof Array)) {
    list = [];
    for (k in errors) {
      if (errors.hasOwnProperty(k)) {
        list.push(errors[k]);
      }
    }
  } else {
    list = errors;
  }

  if (!list || list.length === 0) {
    return null;
  }

  return (
    <ul className="errors">
      {list.map((error, key) => <li key={key}><I18n message={error}/></li>)}
    </ul>
  );
};

Errors.propTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
    PropTypes.string
  ])
};

export default Errors;



// WEBPACK FOOTER //
// ./src/js/Component/Errors.jsx